import { api } from "../utils/api";

const getJobQueue = async () => {
  const res = await api.get("Jobs/myQueue");
  return res.data;
};

const markAsRead = async jobId => {
  const res = await api.post(`Jobs/${jobId}/read`);
  return res.data;
};

const AclService = {
  getJobQueue,
  markAsRead
};

export default AclService;
